const rootWrapperCls = "_61rdnwtuv";
const wrapperCls = "_61w7abg1j";
const textWrapperCls = "_61t1hfasll";
const labelList = "_61l1s669b5";
const labelListElement = "_61l9ahcl6";
const title = "_61tm3yu8r";
const author = "_61ap4qrwl";

export { author, labelList, labelListElement, rootWrapperCls, textWrapperCls, title, wrapperCls };
import "./_card.style.linaria.module.css";
//# sourceMappingURL=_card.style.js.map
